module.exports = __webpack_public_path__ + "static/media/py.98e0fb12.svg";